import React from 'react';
import QRCode from 'qrcode.react';

function QrRastreoPaq({ value, idCode }) {
  return (
    <div>
      <QRCode id={idCode} value={value} size={144} bgColor="#FFF" fgColor="#000" level="H" />
    </div>
  );
}

export default QrRastreoPaq;
